import { estimateBoxes, boxSavings } from './memys-pricing.js';

/** Presentation only. All cart prices and discounts remain Shopify-owned. */
class MemysPurchaseOptions extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.details = this.closest('.product-details');
    this.details?.addEventListener('quantity-selector:update', () => this.sync(), { signal });
    this.details?.addEventListener('input', () => this.sync(), { signal });
    this.details?.addEventListener('blur', () => this.sync(), { signal, capture: true });
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-memys-quantity]');
      if (!button || button.disabled) return;
      const selector = this.selector;
      if (!selector) return;
      selector.setValue(button.dataset.memysQuantity);
      selector.onQuantityChange();
      selector.updateButtonStates();
      this.sync();
    }, { signal });
    document.addEventListener('cart:update', (event) => {
      if (event.detail?.resource?.items) {
        const input = this.selector?.querySelector('input');
        const item = event.detail.resource.items.find(item => String(item.variant_id) === this.selector?.dataset.variantId);
        if (input && item) input.dataset.cartQuantity = String(item.quantity);
      }
      this.sync();
    }, { signal });
    this.closest('.shopify-section')?.addEventListener('variant:update', (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      if (variant?.price != null) this.dataset.price = String(variant.price);
      this.hidden = !variant?.available;
      this.sync();
    }, { signal });
    customElements.whenDefined('quantity-selector-component').then(() => this.isConnected && this.sync());
  }
  disconnectedCallback() { this.abort?.abort(); }
  get selector() { return this.details?.querySelector('product-form-component quantity-selector-component'); }
  money(cents) {
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: this.dataset.currency || 'CLP', }).format(cents / 100);
  }
  updateSavings(node, savings, template) {
    if (!node) return;
    node.hidden = savings <= 0;
    node.textContent = savings > 0 ? (template || '').replace('__AMOUNT__', this.money(savings)) : '';
  }
  sync() {
    const selector = this.selector;
    if (!selector?.getCurrentValues) return;
    const values = selector.getCurrentValues();
    const quantity = values.value;
    const price = Number(this.dataset.price);
    const maximum = selector.getEffectiveMax();
    for (const button of this.querySelectorAll('[data-memys-quantity]')) {
      const q = Number(button.dataset.memysQuantity);
      button.setAttribute('aria-pressed', String(q === quantity));
      button.disabled = q < values.min || (q - values.min) % values.step !== 0 || (maximum != null && q > maximum) || selector.querySelector('input').disabled;
      button.querySelector('[data-memys-estimate]').textContent = this.money(estimateBoxes(price, q, this.dataset.currency || 'CLP'));
      this.updateSavings(button.querySelector('[data-memys-card-savings]'), boxSavings(price, q, this.dataset.currency || 'CLP'), this.dataset.savingsTemplate);
    }
    this.querySelector('[data-memys-selected-total]').textContent = this.money(estimateBoxes(price, quantity, this.dataset.currency || 'CLP'));
    this.updateSavings(this.querySelector('[data-memys-selected-savings]'), boxSavings(price, quantity, this.dataset.currency || 'CLP'), this.dataset.selectedSavingsTemplate);
  }
}
if (!customElements.get('memys-purchase-options')) customElements.define('memys-purchase-options', MemysPurchaseOptions);

document.addEventListener('variant:update', (event) => {
  const details = event.target.closest?.('.shopify-section')?.querySelector('.product-details');
  const unit = details?.querySelector('[data-memys-egg-count]');
  const variant = event.detail?.resource;
  if (!unit || variant?.price == null) return;
  unit.querySelector('[data-memys-per-egg]').textContent = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(variant.price / 100 / Number(unit.dataset.memysEggCount));
});
